import React from "react";
import { ChecklistItem, makeChecklistItem } from "../shared/types";
import * as S from "../shared/styles";

// ----------------------------  Helpers  ----------------------------

function reorder(list: ChecklistItem[]): ChecklistItem[] {
  return list.map((item, i) => ({ ...item, display_order: i }));
}

// ----------------------------  ChecklistBuilder  ----------------------------

interface ChecklistBuilderProps {
  items: ChecklistItem[];
  onChange: (items: ChecklistItem[]) => void;
}

const ChecklistBuilder: React.FC<ChecklistBuilderProps> = ({ items, onChange }) => {
  const add = () => onChange([...items, makeChecklistItem({ display_order: items.length })]);
  const update = (id: string, patch: Partial<ChecklistItem>) =>
    onChange(items.map((i) => (i.id === id ? { ...i, ...patch } : i)));
  const remove = (id: string) => onChange(reorder(items.filter((i) => i.id !== id)));
  const moveItem = (id: string, dir: number) => {
    const idx = items.findIndex((i) => i.id === id);
    const j = idx + dir;
    if (j < 0 || j >= items.length) return;
    const copy = [...items];
    [copy[idx], copy[j]] = [copy[j], copy[idx]];
    onChange(reorder(copy));
  };

  return (
    <div>
      {items.map((item, idx) => (
        <div key={item.id} style={S.checklistRow}>
          <span style={S.checklistIndex}>{idx + 1}.</span>
          <input
            style={{ ...S.formInput, flex: 1 }}
            value={item.label}
            onChange={(e) => update(item.id, { label: e.target.value })}
            placeholder="Checklist item"
          />
          <button
            style={{ ...S.fieldCardActionBtn, opacity: idx === 0 ? 0.3 : 1 }}
            disabled={idx === 0}
            onClick={() => moveItem(item.id, -1)}
            title="Move up"
          >
            ↑
          </button>
          <button
            style={{ ...S.fieldCardActionBtn, opacity: idx === items.length - 1 ? 0.3 : 1 }}
            disabled={idx === items.length - 1}
            onClick={() => moveItem(item.id, 1)}
            title="Move down"
          >
            ↓
          </button>
          <button style={S.fieldCardRemoveBtn} onClick={() => remove(item.id)} title="Remove">
            ✕
          </button>
        </div>
      ))}
      <button style={{ ...S.btnOutline, width: "100%" }} onClick={add}>
        + Add Checklist Item
      </button>
    </div>
  );
};

export default ChecklistBuilder;
